import { PrivateLeaseQuestion } from '@hb/domain/steps/financial-obligation';
import { PrivateLeaseStoreService } from '@hb/modules/financial-obligations/private-lease/private-lease-store.service';
import { PreviousButtonComponent } from '@hb/modules';
import { PrivateLeaseAmountComponent } from '@hb/modules/financial-obligations/private-lease/private-lease-amount/private-lease-amount.component';
import { PrivateLeaseMonthsComponent } from '@hb/modules/financial-obligations/private-lease/private-lease-months/private-lease-months.component';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'private-lease',
    templateUrl: './private-lease.component.html',
    imports: [PreviousButtonComponent, PrivateLeaseAmountComponent, PrivateLeaseMonthsComponent, ApContentPipe],
    styleUrls: ['../../global/global.scss']
})
export class PrivateLeaseComponent implements OnInit, OnDestroy {
    protected readonly store = inject(PrivateLeaseStoreService);
    protected activeQuestion: PrivateLeaseQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy() {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showPrivateLeaseAmount(): boolean {
        return (
            this.activeQuestion === PrivateLeaseQuestion.AMOUNT ||
            (this.store.isActiveQuestion(PrivateLeaseQuestion.AMOUNT) && this.store.isSummary)
        );
    }

    showPrivateLeaseMonths(): boolean {
        return (
            this.activeQuestion === PrivateLeaseQuestion.MONTHS ||
            (this.store.isActiveQuestion(PrivateLeaseQuestion.MONTHS) && this.store.isSummary)
        );
    }
}
